import React from "react";
import PropTypes from "prop-types";

//constants
import { layoutModeTypes } from "../../Components/constants/layout";
import { IconButton } from "@mui/material";

const LightDark = ({ layoutMode, onChangeLayoutMode }) => {
  const mode =
    layoutMode === layoutModeTypes["DARKMODE"]
      ? layoutModeTypes["LIGHTMODE"]
      : layoutModeTypes["DARKMODE"];

  return (
    <div className="ms-1 header-item d-none d-sm-flex">
      <IconButton
        onClick={() => onChangeLayoutMode(mode)}
        sx={{ color: "#fff" }}
      >
        <i className="bx bx-moon fs-22"></i>
      </IconButton>
    </div>
  );
};

LightDark.propTypes = {
  layoutMode: PropTypes.string,
  onChangeLayoutMode: PropTypes.func,
};

export default LightDark;
